import { render } from "./AddAgentPage.vue?vue&type=template&id=29e0ea91&ts=true"
import script from "./AddAgentPage.vue?vue&type=script&lang=ts"
export * from "./AddAgentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__